import { useStaticQuery, graphql } from "gatsby"

export const useAgendaEvent = () => {
  const data = useStaticQuery(
    graphql`
      query {
        allNodeEvenements(sort: { fields: field_date_de_debut, order: ASC }) {
          ...AllEvents
        }
        taxonomyTermZoneDefinie(name: { eq: "evenements" }) {
          ...AllEventsTaxo
        }
      }
    `
  )
  return data
}

export const queryEvent = graphql`
  fragment AllEvents on node__evenementsConnection {
    edges {
      node {
        field_date_de_debut(formatString: "DD/MM/YYYY", locale: "fr")
        field_date_de_fin(formatString: "DD/MM/YYYY", locale: "fr")
        fields {
          formatted_field_date_de_fin
          formatted_field_date_de_debut
          formatted_for_compare_field_date_de_fin
          formatted_for_compare_field_date_de_debut
        }
        title
        drupal_id
        path {
          alias
        }
        relationships {
          field_taxonomie_thematique {
            name
          }
          field_image_event {
            localFile {
              extension
              SlugifiedPublicUrl
            }
          }
        }
      }
    }
  }
`

export const queryTaxo = graphql`
  fragment AllEventsTaxo on taxonomy_term__zone_definie {
    field_label
    description {
      processed
    }
  }
`
